export default "__VITE_ASSET__ep_ohsoE__"